<template>
  <table class="table border-top border-start border-end border-bottom">
    <thead>
      <tr class="border-bottom">
        <th scope="col" class="border-end">Date</th>
        <th scope="col" class="border-end">Bid</th>
        <th scope="col" class="border-end">Number</th>
        <!-- <th scope="col" class="border-end">Auto</th> -->
      </tr>
    </thead>
    <tbody>
      <tr v-for="offer in latestAuctionOffers" :key="offer._id">
        <td>{{ $formatDate(offer.creationDate) }}</td>
        <td><b>{{ $convertCurrency(offer.prezzo) }}</b></td>
        <td>{{ offer.numero }}</td>
        <!-- <td>{{ offer._offerente?.[0] }}</td> -->
      </tr>
    </tbody>
  </table>
</template>

<script>

export default {
  props: {
    latestAuctionOffers: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped="scoped">
td {
  width: 20%;
}
th, td {
  border: 0;
}
</style>